import React, { useState } from 'react';
import api from '../api';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/api/auth/forgot-password', { email });
    } catch (err) {
      // Always show success to prevent email enumeration
    } finally {
      setLoading(false);
      setSubmitted(true);
    }
  };

  if (submitted) {
    return (
      <div className="form-page">
        <div className="form-container" style={{ maxWidth: '480px' }}>
          <div className="success-message">
            <h2>Check Your Email</h2>
            <p>If an account exists for <strong>{email}</strong>, we've sent a password reset link. It may take a minute or two to arrive.</p>
            <p className="text-muted" style={{ fontSize: '0.85rem' }}>The link expires in 1 hour. If you don't see it, check your spam folder.</p>
            <a href="/login" className="btn btn-primary" style={{ marginTop: '1rem' }}>Back to Login</a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="form-page">
      <div className="form-container" style={{ maxWidth: '480px' }}>
        <h1>Forgot Password</h1>
        <p>Enter your email address and we'll send you a link to reset your password.</p>
        <form onSubmit={handleSubmit} className="registration-form">
          <div className="form-group">
            <label>Email Address <span className="required">*</span></label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
            />
          </div>
          <button type="submit" disabled={loading} className="btn btn-primary">
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>
        <p style={{ marginTop: '1.5rem', textAlign: 'center' }}>
          <a href="/login">← Back to Login</a>
        </p>
      </div>
    </div>
  );
}

export default ForgotPassword;
